import { ClientEvents } from 'common/events/ClientEvents';
import React, { useCallback } from 'react';
import { Lightbox } from 'src/shared/design-system/Lightbox';
import { useTracker } from 'src/shared/hooks/useTracker';
import { ShefImage } from '../../components/ShefImage';

const LIGHTBOX_SHEF_IMAGE_WIDTH = 215;

interface ConsumerOrderShefImageProps {
  smallScreen: boolean;
  shefId: string;
  shefImageUrl: string;
}

export const ConsumerOrderShefImage: React.FC<ConsumerOrderShefImageProps> = ({
  smallScreen,
  shefId,
  shefImageUrl,
}) => {
  const tracker = useTracker();

  const handleProfileImageClick = useCallback(
    () => tracker.track(ClientEvents.SHEF_PROFILE_IMAGE_CLICK, { shefId }),
    [tracker, shefId]
  );

  const shefImage = <ShefImage src={shefImageUrl} />;

  return smallScreen ? (
    <Lightbox
      onShow={handleProfileImageClick}
      lightboxContent={
        <ShefImage width={LIGHTBOX_SHEF_IMAGE_WIDTH} smallScreenWidth={LIGHTBOX_SHEF_IMAGE_WIDTH} src={shefImageUrl} />
      }>
      {shefImage}
    </Lightbox>
  ) : (
    shefImage
  );
};
